var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('m-popup-m-body',{attrs:{"title":_vm.title}},[_c('m-articles')],1),_vm._v(" "),_c('div',{staticClass:"m-btns"},[_c('div',{staticClass:"m-btn -st",on:{"click":function($event){return _vm.onClose()}}},[_vm._v("キャンセル")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }